(() => {
  const links = [...document.querySelectorAll('.header-cart')];
  if (!links.length) return;
  const update = value => {
    const count = Math.max(0, Number(value) || 0);
    links.forEach(link => {
      const badge = link.querySelector('[data-cart-count]');
      if (badge) badge.textContent = String(count);
      link.setAttribute('aria-label', `View shopping cart, ${count} ${count === 1 ? 'item' : 'items'}`);
    });
  };
  let pending;
  const refresh = () => {
    if (pending) return pending;
    const root = window.Shopify?.routes?.root || '/';
    pending = fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(response => response.ok ? response.json() : null)
      .then(cart => { if (cart && typeof cart.item_count === 'number') update(cart.item_count); })
      .catch(() => {})
      .finally(() => { pending = null; });
    return pending;
  };
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('cartUpdate', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('shopify:cart:updated', refresh);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
})();
